// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bonsly: PokeData = {
  "id": 438,
  "name": "bonsly",
  "height": 5,
  "weight": 150,
  "base_experience": 58,
  "types": [
    PokeType.ROCK
  ],
  "api_moves": [
    "slam",
    "tackle",
    "double-edge",
    "low-kick",
    "counter",
    "rock-throw",
    "mimic",
    "rock-slide",
    "flail",
    "feint-attack",
    "rollout",
    "fake-tears",
    "rock-tomb",
    "iron-defense",
    "block",
    "copycat",
    "sucker-punch",
    "stealth-rock",
    "head-smash",
    "tearful-look"
  ],
  "moves": [
    "tackle",
    "rock-throw",
    "rock-slide",
    "rock-tomb",
    "stealth-rock",
    "rock-blast",
    "ancient-power",
    "stone-axe",
    "power-siphon",
    "seismic-toss",
    "stone-crush",
    "boulder_bash",
    "rock-smash"
  ],
  "evolution_chain": {
    "id": 91,
    "item": {
      "name": "rock-incense"
    },
    "species": [
      {
        "name": "bonsly",
        "order": 214,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sudowoodo",
        "order": 215,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": 438,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "mimic"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60,
    "speed": 10,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
